//文字コードはutf-8

/* スクロールリビール
 * IntersectionObserverで [data-reveal] 要素を監視し、
 * ビューポートに入ったら is-revealed クラスを付与する。
 * 実際のアニメーションは CSS 側で定義（base/_animations.scss）。
 *
 * data-reveal="up" | "fade" | "scale" | "rotate"   ← アニメーションの種類
 * data-reveal-delay="120"                          ← ms 単位の開始遅延（任意）
 * data-reveal-once="false"                         ← 既定は true（一度きり）
========================================================*/

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function initScrollReveal() {
    // [data-reveal] = 要素自体にフェード/スライドを適用
    // [data-ribbon-wipe] = 要素の :before（リボン背景）に布のワイプを適用
    // どちらも is-revealed クラスで発火（CSS 側で挙動を分岐）
    const $targets = $('[data-reveal], [data-ribbon-wipe]');
    if (!$targets.length) return;

    // モーション削減設定 or IntersectionObserver 非対応環境では即座に表示
    if (REDUCED_MOTION || typeof IntersectionObserver === 'undefined') {
        $targets.addClass('is-revealed');
        return;
    }

    // 個別要素ごとに delay を CSS 変数として注入（CSS 側で transition-delay に利用）
    $targets.each(function () {
        const delay = parseInt($(this).attr('data-reveal-delay') || '0', 10);
        if (delay > 0) {
            this.style.setProperty('--reveal-delay', delay + 'ms');
        }
    });

    // [data-ribbon-wipe] のリボン画像は CSS background なので、
    // 擬似要素が初描画されるまで読み込まれず、リビール直後に「ポン」と現れてしまう。
    // 観測時点でロード完了を待ってから is-revealed を付与するため、
    // 各要素の ::before / ::after の background-image URL を取り出して
    // Promise でロード状態を保持する。初期化時から先読みすることで
    // ユーザーが到達する頃にはキャッシュ済みであることを期待する。
    const ribbonReadyMap = new WeakMap();
    function ensureRibbonImagesLoaded(el) {
        if (ribbonReadyMap.has(el)) return ribbonReadyMap.get(el);
        const urls = new Set();
        ['::before', '::after'].forEach(function (pseudo) {
            const bg = getComputedStyle(el, pseudo).backgroundImage;
            if (!bg || bg === 'none') return;
            const re = /url\(\s*(?:"([^"]+)"|'([^']+)'|([^)\s]+))\s*\)/g;
            let m;
            while ((m = re.exec(bg)) !== null) {
                urls.add(m[1] || m[2] || m[3]);
            }
        });
        const ready = Promise.all([...urls].map(function (url) {
            return new Promise(function (resolve) {
                const img = new Image();
                img.onload = img.onerror = function () { resolve(); };
                img.src = url;
            });
        }));
        ribbonReadyMap.set(el, ready);
        return ready;
    }

    // 監視開始前にプリロードを発火させておく（fire-and-forget）
    $targets.filter('[data-ribbon-wipe]').each(function () {
        ensureRibbonImagesLoaded(this);
    });

    const observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            const target = entry.target;
            const $el = $(target);
            const once = $el.attr('data-reveal-once') !== 'false';
            const isRibbon = target.hasAttribute('data-ribbon-wipe');

            if (isRibbon) {
                // 背景画像のロード完了を待ってからアニメーション開始
                ensureRibbonImagesLoaded(target).then(function () {
                    $el.addClass('is-revealed');
                });
            } else {
                $el.addClass('is-revealed');
            }

            if (once) obs.unobserve(target);
        });
    }, {
        // 要素が 12% 顔を出した時点で発火（早すぎず遅すぎず）
        threshold: 0.12,
        // ビューポート下端の 8% 手前から監視を開始
        rootMargin: '0px 0px -8% 0px'
    });

    $targets.each(function () {
        observer.observe(this);
    });
}
